import { get } from 'lodash';
import { createSelector } from 'reselect';
import { ROOT_STATE_KEY } from '../constants';

const insurancePickerSelector = createSelector(
    state => get(state, ROOT_STATE_KEY),
    insurance => insurance,
);

export default insurancePickerSelector;
